function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useEffect } from "react";
import { useRemoteModulePreload } from "./remote-module-preload";
import { getRemoteComponent } from "../globalScriptProviders";
import logger from "../logger";
export var remoteModuleRefs = {};
export var getRemotePageParameters = /*#__PURE__*/ _async_to_generator(function() {
    var executionPromises, results;
    return _ts_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                executionPromises = Object.values(remoteModuleRefs).reduce(function(executions, param) {
                    var modules = param.modules, counter = param.counter;
                    Object.entries(modules).forEach(function(param) {
                        var _param = _sliced_to_array(param, 2), mod = _param[0], exec = _param[1];
                        // mod is the key, exec is the value
                        // exec is the promise created by getRemoteComponent
                        if (counter[mod] > 0) {
                            executions.push(exec.then(/*#__PURE__*/ _async_to_generator(function(param) {
                                var remote, remoteModule, _remoteModule, parameters, error;
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            remote = param.remote, remoteModule = param.value;
                                            _state.label = 1;
                                        case 1:
                                            _state.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            if (!((_remoteModule = remoteModule) == null ? void 0 : _remoteModule.default)) {
                                                throw new Error("Remote script " + remote + "(" + mod + ") does not contain a default export");
                                            }
                                            return [
                                                4,
                                                remoteModule.default()
                                            ];
                                        case 2:
                                            parameters = _state.sent();
                                            // Must be json serializable
                                            JSON.stringify(parameters);
                                            return [
                                                2,
                                                parameters
                                            ];
                                        case 3:
                                            error = _state.sent();
                                            // Handling any errors here should allow the other requests to continue
                                            logger.error("Remote Page Parameter Script " + remote + "(" + mod + ") must return a JSON serializable object", error);
                                            return [
                                                2,
                                                {}
                                            ];
                                        case 4:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })));
                        }
                    });
                    return executions;
                }, []);
                return [
                    4,
                    Promise.all(executionPromises)
                ];
            case 1:
                results = _state.sent();
                return [
                    2,
                    results.reduce(function(acc, parameters) {
                        return _extends({}, acc, parameters);
                    }, {})
                ];
        }
    });
});
export function useFederatedTargetPageParameters(param) {
    var remote = param.remote, mod = param.module;
    // If we are server side mark this module for preload
    useRemoteModulePreload({
        remote: remote,
        module: mod
    });
    useEffect(function() {
        if (!remoteModuleRefs) {
            logger.warn("An attempt to use useFederatedTargetPageParameters was made, when the HOC withFederatedTargetPageParameters was not used in the application!");
            return function() {
            // noop
            };
        }
        // This is doing reference counting to keep track of what modules were used
        // This is used on the client to tell the cache if it should attempt to get module or not when looking for global params
        var prefixedMod = mod.startsWith("./") ? mod : "./" + mod;
        var ref = remoteModuleRefs[remote] || {
            remote: remote,
            modules: {},
            counter: {}
        };
        remoteModuleRefs[remote] = ref;
        ref.counter[prefixedMod] = (ref.counter[prefixedMod] || 0) + 1;
        if (!ref.modules[prefixedMod]) {
            // Attempt to execute the module and save the result
            ref.modules[prefixedMod] = getRemoteComponent({
                remote: remote,
                component: prefixedMod
            }).then(function(param) {
                var factoryPromise = param.component;
                return factoryPromise;
            }).then(function(factory) {
                return factory();
            }).then(function(v) {
                return {
                    value: v,
                    mod: prefixedMod,
                    remote: remote
                };
            }).catch(function(error) {
                logger.error("Remote Page Parameter Script " + remote + "(" + mod + ") execution", error);
                return null;
            });
        }
        return function() {
            // if this hook is used in a component that unmounts, we will decrement the reference counter
            // this way, if we no longer have any components that want to use these target page params, the cache will not append them to the payload
            // allowing page specific page params instead of completely global params
            ref.counter[prefixedMod] -= 1;
        };
    }, [
        remote,
        mod
    ]);
}

//# sourceMappingURL=federated-target-page-parameters.js.map